<template>
  <div class="omsMain">
    <PcOms class="PC"/>
    <MdOms class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdOms from './MdOms.vue'
// pc端
import PcOms from './PcOms.vue'
export default {
  name: 'newsMain',
  components: {
    PcOms,
    MdOms
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .omsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .omsMain{
    .MD{
      display: none;
    }
  }
}
</style>
